/**
 * Calendar context is used to manage working time configurations for tasks and projects.
 * It provides access to calendar settings including working hours, holidays, and exceptions.
 */
export class CalendarContext {
    constructor(parent, calendar) {
        this.defaultHolidays = [];
        this.exceptionsRanges = [];
        this.parent = parent;
        this.calendar = calendar;
        this.initialize();
    }
    initialize() {
        this.buildDefaultHolidays();
        this.buildExceptionsCollection();
    }
    buildDefaultHolidays() {
        const holidays = this.calendar['propName'] === 'projectCalendar' ? this.parent.calendarModule.holidays : this.calendar.holidays;
        const overrides = this.calendar.exceptions;
        for (let i = 0; i < holidays.length; i++) {
            const holiday = holidays[i];
            const fromDate = holiday.from ? new Date(holiday.from) : new Date(holiday.to);
            const toDate = holiday.to ? new Date(holiday.to) : new Date(holiday.from);
            for (let d = new Date(fromDate); d <= toDate; d.setDate(d.getDate() + 1)) {
                const timestamp = new Date(d).setHours(0, 0, 0, 0);
                let isOverridden = false;
                for (let j = 0; j < overrides.length; j++) {
                    const overrideDate = new Date(overrides[j].from).setHours(0, 0, 0, 0);
                    if (overrideDate === timestamp) {
                        isOverridden = true;
                        break;
                    }
                }
                if (!isOverridden) {
                    this.defaultHolidays.push(timestamp);
                }
            }
        }
    }
    buildExceptionsCollection() {
        const overrides = this.calendar.exceptions;
        for (let i = 0; i < overrides.length; i++) {
            const override = overrides[i];
            const fromDate = new Date(override.from);
            const toDate = new Date(override.to);
            const id = `exception_${i}`;
            this.exceptionsRanges.push({
                id,
                from: fromDate,
                to: toDate
            });
        }
    }
    /**
     * Checks if the provided date falls within any exception period.
     * @param {Date} date - The date to check.
     * @returns {boolean} True if the date is part of an exception, otherwise false.
     * @public
     */
    getExceptionForDate(date) {
        const target = new Date(date.getTime());
        target.setHours(0, 0, 0, 0);
        for (const range of this.exceptionsRanges) {
            const from = new Date(range.from);
            const to = new Date(range.to);
            from.setHours(0, 0, 0, 0);
            to.setHours(0, 0, 0, 0);
            if (target >= from && target <= to) {
                return true;
            }
        }
        return false;
    }
}
